import { isValidBillingEmail } from './billingEmailSchema';

(() => {
  //onload
  document.addEventListener('DOMContentLoaded', () => {

    jQuery('select[name="custom_shipping_option"]').on('change', function() {
      var selected = jQuery(this).val();

      if (selected) {
        jQuery.ajax({
          type: 'POST',
          url: '/?wc-ajax=update_order_review',
          data: {
            security: wc_checkout_params.update_order_review_nonce,
            'shipping_method[0]': selected
          },
          success: function(response) {
            jQuery('body').trigger('update_checkout');
          }
        });
      }
    });

    const btnsChangePayment = [
      ...document.querySelectorAll('.qte-payment-method'),
    ];

    const activatePaymentButton = (btn) => {
      if (!btn) {
        return;
      }

      btnsChangePayment.forEach((b) => {
        b.classList.remove('active');
      });

      btn.classList.add('active');

      const paymentMethod = document.querySelector('#payment_method_' + btn.id);

      if (!paymentMethod) {
        console.error(npVars.payment_method_not_found_string);
        return;
      }

      if (!paymentMethod.checked) {
        paymentMethod.click();
      }
    };

    const PAYPAL_GATEWAY_ID = 'ppcp-gateway';

    const isPayPalContinuation = () =>
      document.querySelector('#ppcp-cancel') !== null;

    const isPayPalSelected = () => {
      const paypalRadio = document.querySelector(
        '#payment_method_' + PAYPAL_GATEWAY_ID,
      );
      return paypalRadio && paypalRadio.checked;
    };

    const getPayPalButton = () =>
      document.querySelector('.qte-payment-method#' + PAYPAL_GATEWAY_ID);

    const syncSelectedPaymentMethod = () => {
      if (isPayPalContinuation() || isPayPalSelected()) {
        activatePaymentButton(getPayPalButton());
        return;
      }

      const activeBtn = document.querySelector('.qte-payment-method.active');
      activatePaymentButton(activeBtn || btnsChangePayment[0]);
    };

    if (isNaN(btnsChangePayment.length) || btnsChangePayment.length === 0) {
      console.error(
        npVars.payment_method_buttons_not_found_string,
      );
    } else {
      btnsChangePayment.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          activatePaymentButton(btn);
        });
      });

      if (isPayPalContinuation()) {
        activatePaymentButton(getPayPalButton());
      } else {
        btnsChangePayment[0].classList.add('active');
        syncSelectedPaymentMethod();
      }
    }

    jQuery(document.body).on('updated_checkout', syncSelectedPaymentMethod);
    jQuery(document.body).on('checkout_place_order', () => {
      if (isPayPalContinuation() || isPayPalSelected()) {
        activatePaymentButton(getPayPalButton());
      }
    });
  });

  //submit discount code form
  jQuery(document).ready(function ($) {
    const btnDiscount = $('.coupon-button');

    btnDiscount.on('click', function (e) {
      e.preventDefault();

      const inputDiscount = $('#coupon_code');
      const coupon = inputDiscount.val();

      if (!coupon) return;

      // Disable button and show loading state
      btnDiscount.prop('disabled', true).text(npVars.applying_coupon_label);

      $.ajax({
        type: 'POST',
        url: npVars.ajax_url,
        data: {
          action: 'np_coupons',
          nonce: npVars.nonce,
          add_coupon_code: coupon
        },
        success: function (result) {
          // Re-enable button
          btnDiscount.prop('disabled', false).text(npVars.apply_coupon_label);

          inputDiscount.val(''); // Clear the input field

          jQuery('body').trigger('update_checkout');
          refreshCoupons();
        },
        error: function (xhr) {
          btnDiscount.prop('disabled', false).text(npVars.apply_coupon_label);
          $('.woocommerce-notices-wrapper').html('<ul class="woocommerce-error"><li>'+ npVars.something_went_wrong_label + '</li></ul>');

          console.log(xhr);
        },
      });
    });

    // If press [data-remove-coupon] button
    $(document).on('click', '[data-remove-coupon]', function (e) {
      e.preventDefault();

      const coupon_code = $(this).data('remove-coupon');

      var btn = $(this);
      couponMessage(npVars.coupon_removing_string);
      btn.remove();

      jQuery.ajax({
        type: 'POST',
        url: npVars.ajax_url,
        data: {
          action: 'np_coupons',
          nonce: npVars.nonce,
          coupon_code: coupon_code
        },
        success: function (response) {
          jQuery('body').trigger('update_checkout');
          refreshCoupons(false);
        },
        error: function () {
          console.error(npVars.coupons_error_string);
        },
      });

    });
    function couponMessage(message) {
      $('.np-applied-coupons').html(message);
    }

    function refreshCoupons(showLoading = true) {

      if (showLoading)
        couponMessage('<i>'+npVars.coupons_loading_string+'...</i>');

      // If we are on /cart page, we just refresh the page.
      if (window.location.pathname === '/cart/') {
        window.location.reload();
        return;
      }

      jQuery.ajax({
        type: 'POST',
        url: npVars.ajax_url,
        data: {
          action: 'np_coupons',
          nonce: npVars.nonce
        },
        success: function (response) {
          jQuery('.np-applied-coupons').html(response);
        },
        error: function () {
          console.error(npVars.coupons_error_string || 'Error fetching applied coupons');
        }
      });
    }

    function applyBillingEmailValidationState() {
      const $field = jQuery('#billing_email_field');
      const $input = jQuery('#billing_email');
      const email = String($input.val() || '').trim();

      if (!$field.length || !$input.length) {
        return true;
      }

      if (!email) {
        $field.removeClass('woocommerce-invalid-email');
        return !$field.hasClass('woocommerce-invalid');
      }

      const isValid = isValidBillingEmail(email);

      if (isValid) {
        $field.removeClass('woocommerce-invalid woocommerce-invalid-email');
        $input.removeAttr('aria-invalid');
        $field.addClass('woocommerce-validated');
        return true;
      }

      $field
        .removeClass('woocommerce-validated')
        .addClass('woocommerce-invalid woocommerce-invalid-email');
      $input.attr('aria-invalid', 'true');
      return false;
    }

    function scheduleBillingEmailValidation() {
      window.setTimeout(applyBillingEmailValidationState, 0);
    }

    // Run after WooCommerce validate_field (focusout clears our classes otherwise).
    jQuery('form.checkout').on(
      'focusout change validate input',
      '#billing_email',
      scheduleBillingEmailValidation,
    );

    jQuery(document.body).on(
      'checkout_error updated_checkout',
      scheduleBillingEmailValidation,
    );

    jQuery(document.body).on('checkout_place_order', function () {
      const email = String(jQuery('#billing_email').val() || '').trim();

      if (!email) {
        return applyAdditionalInfoValidationState(true);
      }

      const isEmailValid = applyBillingEmailValidationState();

      if (!isEmailValid) {
        jQuery('html, body').animate(
          {
            scrollTop: jQuery('#billing_email_field').offset().top - 100,
          },
          500,
        );
        return false;
      }

      return applyAdditionalInfoValidationState(true);
    });

    const ADDITIONAL_INFO_MAX_LENGTH = Number(
      npVars.additional_info_max_length || 1000,
    );

    function getAdditionalInfoLength() {
      return String(jQuery('#additional_info').val() || '').length;
    }

    function updateAdditionalInfoCounter() {
      const $counter = jQuery('#additional_info_counter .additional-info-counter__count');
      if (!$counter.length) {
        return;
      }
      $counter.text(getAdditionalInfoLength());
    }

    function applyAdditionalInfoValidationState(scrollToField = false) {
      const $field = jQuery('#additional_info_field');
      const $input = jQuery('#additional_info');
      const length = getAdditionalInfoLength();

      if (!$field.length || !$input.length) {
        return true;
      }

      updateAdditionalInfoCounter();

      if (length <= ADDITIONAL_INFO_MAX_LENGTH) {
        $field.removeClass('woocommerce-invalid');
        $input.removeAttr('aria-invalid');
        jQuery('.additional-info-validation-error').remove();
        return true;
      }

      $field.removeClass('woocommerce-validated').addClass('woocommerce-invalid');
      $input.attr('aria-invalid', 'true');

      if (!jQuery('.additional-info-validation-error').length) {
        const message =
          npVars.additional_info_too_long_string ||
          'Additional information must be 1000 characters or fewer. Please shorten your message to continue.';
        jQuery('.woocommerce-notices-wrapper')
          .first()
          .prepend(
            '<ul class="woocommerce-error additional-info-validation-error"><li>' +
              message +
              '</li></ul>',
          );
      }

      if (scrollToField) {
        jQuery('html, body').animate(
          {
            scrollTop: $field.offset().top - 100,
          },
          500,
        );
      }

      return false;
    }

    jQuery('form.checkout').on(
      'input change',
      '#additional_info',
      function () {
        updateAdditionalInfoCounter();
        applyAdditionalInfoValidationState(false);
      },
    );

    updateAdditionalInfoCounter();

    const isRequiredCheckoutFormComplete = () => {
      const $rows = jQuery(
        '.woocommerce-billing-fields .validate-required',
      );
      if (!$rows.length) {
        return true;
      }

      let complete = true;
      $rows.each(function () {
        const $row = jQuery(this);
        const $field = $row
          .find('input, select, textarea')
          .not('[type="hidden"]')
          .first();
        if (!$field.length) {
          return;
        }

        const val = String($field.val() || '').trim();
        if (!val) {
          complete = false;
          return false;
        }

        if ($field.attr('id') === 'billing_email' && !isValidBillingEmail(val)) {
          complete = false;
          return false;
        }
      });

      return complete && applyAdditionalInfoValidationState(false);
    };

    let expressCheckoutSnapshotTimer;
    const persistCheckoutFormForExpress = () => {
      window.clearTimeout(expressCheckoutSnapshotTimer);
      expressCheckoutSnapshotTimer = window.setTimeout(() => {
        if (isRequiredCheckoutFormComplete()) {
          jQuery(document.body).trigger('update_checkout');
        }
      }, 400);
    };

    jQuery('form.checkout').on(
      'input change blur',
      '.woocommerce-billing-fields input, .woocommerce-billing-fields select, .woocommerce-billing-fields textarea, #additional_info, #custom_shipping_option, #company_vat_number',
      persistCheckoutFormForExpress,
    );
    persistCheckoutFormForExpress();

  });

})();
